/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RegionsControllerFindOneQueryResponse, RegionsControllerFindOnePathParams, RegionsControllerFindOneQueryParams, RegionsControllerFindOne400, RegionsControllerFindOne401, RegionsControllerFindOne403, RegionsControllerFindOne404 } from "../../models/regionsController/RegionsControllerFindOne";

function getRegionsControllerFindOneUrl(id: RegionsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/regions/${id}` as const }  
  return res
}

/**
 * @summary Get a region by ID
 * {@link /api/v1/regions/:id}
 */
export async function regionsControllerFindOne(id: RegionsControllerFindOnePathParams["id"], params?: RegionsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RegionsControllerFindOneQueryResponse, ResponseErrorConfig<RegionsControllerFindOne400 | RegionsControllerFindOne401 | RegionsControllerFindOne403 | RegionsControllerFindOne404>, unknown>({ method : "GET", url : getRegionsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}